export const BUILD_MODE = process.env.BUILD_MODE || 'dev'
export const IS_PRODUCTION_SITE = process.env.BUILD_MODE === 'production'
export const DEPLOYMENT_INFO_FILE = 'deployment.json'

export const TIMEOUT_MILLISECONDS = 90 * 1000
export const EMAILING_STATUS_CODE = 202

export const WEBSITE_BASE_URL =
  process.env.WEBSITE_BASE_URL ||
  'https://dev.podfoods.co'

export const WEBSITE_LP_BASE_URL =
  process.env.WEBSITE_LP_BASE_URL ||
  'https://lp.dev.podfoods.co'

export const WEBSITE_BROKER_BASE_URL =
  process.env.WEBSITE_BROKER_BASE_URL ||
  'https://broker.dev.podfoods.co'

export const API_BASE_URL =
  process.env.API_BASE_URL ||
  'https://apidev.podfoods.co'

export const SOCKET_BASE_URL =
  process.env.SOCKET_BASE_URL ||
  'wss://apidev.podfoods.co/cable'

export const GTM_TRACKING_CODE =
  process.env.GTM_TRACKING_CODE ||
  'GTM-N33FKQS'

export const STRIPE_PUBLIC_KEY =
  process.env.STRIPE_PUBLIC_KEY ||
  'pk_test_Xv2UGpV9lonKGb1MUEj8KDTV'

export const STRIPE_CONNECT_DASHBOARD_STANDARD = 'https://connect.stripe.com/dashboard'
export const STRIPE_OAUTH_ENDPOINT_EXPRESS =
  process.env.STRIPE_OAUTH_ENDPOINT_EXPRESS ||
  `https://connect.stripe.com/express/oauth/authorize?redirect_uri=${WEBSITE_BASE_URL}/vendors/settings/payments&client_id=ca_BedHY2HyDkUyFHmjWvgltQ81gVVHZuce`

export const STRIPE_OAUTH_ENDPOINT_STANDARD =
  process.env.STRIPE_OAUTH_ENDPOINT_STANDARD ||
  `https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write&redirect_uri=${WEBSITE_BASE_URL}/vendors/settings/payments&client_id=ca_BedHY2HyDkUyFHmjWvgltQ81gVVHZuce`

export const KANMON_CDN_HOST =
  process.env.KANMON_CDN_HOST ||
  'https://cdn.sandbox.kanmon.dev/kanmon-connect.js'

export const AMPLITUDE_API_KEY =
  process.env.AMPLITUDE_API_KEY ||
  '45d5c4c884bde5a257b75733bdd505c6'

export const CONTENTFUL_SPACE_ID =
  process.env.CONTENTFUL_SPACE_ID || 'zgh5j09dce4p'
export const CONTENTFUL_CDA_ACCESS_TOKEN =
  process.env.CONTENTFUL_CDA_ACCESS_TOKEN || '7fMi-jgdisGUJxivOrdU_1_2nK23bSmLmbWNknNJ8jU'
export const CONTENTFUL_ENVIRONMENT =
  process.env.CONTENTFUL_ENVIRONMENT || 'master'

export const CONTACT_EMAIL = 'hi@podfoods.co'
export const ORDERS_EMAIL = 'orders@podfoods.co'
export const SALES_EMAIL = 'sales@podfoods.co'
export const CAPITAL_EMAIL = 'capital@podfoods.co'
export const BRANDS_EMAIL = 'brands@podfoods.co'
export const FACEBOOK_URL = 'https://www.facebook.com/podfoodsco'
export const INSTAGRAM_URL = 'https://www.instagram.com/podfoods.co'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/pod-foods'
export const YOUTUBE_URL = 'https://www.youtube.com/@podfoods2647'
export const SPOTIFY_URL = 'https://creators.spotify.com/pod/show/pod-podcast9'

export const EXPORT_DATE_FORMAT = 'MM/DD/YY'
export const DATE_FORMAT = 'MM/DD/YY'
export const TIME_FORMAT = 'hh:mm a'
export const DATETIME_FORMAT = 'hh:mm a M/D/Y'
export const ELEMENT_TIME_FORMAT = 'HH:mm'
export const ELEMENT_DATE_FORMAT = 'MM/dd/yy'
export const ELEMENT_DATE_VALUE_FORMAT = 'yyyy-MM-dd'
export const ELEMENT_MONTH_FORMAT = 'yyyy-MM'
export const ELEMENT_MONTH_VALUE_FORMAT = 'MM/yyyy'
export const SETUP_PASSWORD_URL = '/setup-password'

export const DATE_FORMAT_ISO = 'YYYY-MM-DD'

export const PRIMARY_COLOR = '#ffc200'
export const DEBOUNCE_DELAY = 800

export const DATADOG_RUM_CONFIG =
  IS_PRODUCTION_SITE
    ? {
      applicationId: '08cc9dfa-c5de-470c-9222-697ac852bf0f',
      clientToken: 'pub895edf4f361d68dea286a13aaa7d84f1',
      site: 'datadoghq.com',
      service: 'new_pod_web',
      env: BUILD_MODE,
      version: process.env.CURRENT_APP_BRANCH,
      allowedTracingUrls: [API_BASE_URL],
      sampleRate: 100,
      trackLongTasks: true,
      trackInteractions: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input'
    }
    : null

export const ABBR = {
  CHI: 'CHI',
  MA: 'MA',
  NY: 'NY',
  SF: 'SF',
  LA: 'LA',
  DAL: 'DAL',
  FL: 'FL',
  DV: 'DV',
  SAC: 'SAC',
  ATL: 'ATL',
  PHX: 'PHX'
}

export const MAX_CASE_CONFIG_IMAGES = 10
export const MAX_COMPANY_DOCUMENTS = 10
export const MAX_BRAND_SUB_IMAGES = 5
export const MAX_ATTACHMENT_SIZE = 10 * 1000 * 1000
export const ERROR_FILE_SIZE_MESSAGE = 'Maximum file size exceeded. (10MB)'

export const FILE_TYPES = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  png: 'image/png',
  pdf: 'application/pdf',
  csv: 'text/csv'
}

export const POPUP_REFS = {
  VENDOR_SETTING_PAYMENT: 'vendorSettingPaymentPopupRef',
  VENDOR_BRAND: 'vendorBrandPopupRef',
  VENDOR_BRAND_MEDIA_FILES: 'vendorBrandMediaFilesPopupRef',
  VENDOR_PRODUCT: 'vendorProductPopupRef',
  VENDOR_WHOLESALE_WIDGET: 'vendorWholesaleWidgetPopupRef',
  BROKER_VENDOR_COMPANY_SELECT: 'brokerVendorCompanySelect',
  BROKER_VENDOR_USER_INFO: 'brokerVendorUserInfo'
}

export const PFD_ITEM_TYPE = 'LineItems::Direct'
export const WAREHOUSE_ITEM_TYPE = 'LineItems::Warehoused'
export const PRE_ORDER_TYPE = 'PreOrders::Order'
export const ORDER_TYPE = 'Order'

export const PRE_ORDER_ITEM_TYPES = {
  WAREHOUSED: 'Warehoused',
  PFD: 'Direct'
}

export const FULFILLMENT_ORDER_TYPE = {
  CREATE: 'CREATE',
  VIEW_SHIPPO_LABEL: 'VIEW_SHIPPO_LABEL',
  UPDATE_SELF_DELIVER_TO_STORE: 'UPDATE_SELF_DELIVER_TO_STORE',
  UPDATE_POD_DIRECT_STANDARD: 'UPDATE_POD_DIRECT_STANDARD'
}
export const PROMOTION_ACTIONS = {
  FIX_RATE_ADJUSTMENT: 'PromotionActions::FixRateAdjustment',
  PERCENTAGE_ADJUSTMENT: 'PromotionActions::PercentageAdjustment'
}
export const PROMOTION_ACTIONS_TYPES = {
  STACKED: 'stacked',
  DEFAULT: 'default'
}
export const TYPE_MEMO = 'StoreStatementItems::Memo'
export const TYPE_UNAPPLIED = 'StoreStatementPayments::Unapplied'
export const TYPE_APPLIED = 'StoreStatementPayments::Applied'
export const TYPE_SUB_INVOICE = 'StoreStatementItems::ItemSubInvoice'
export const TYPE_ADJUSTMENT = 'StoreStatementItems::Adjustment'

export const VENDOR_PROMOTION_SUBMISSION_TYPE = 'PromotionSubmission'

export const PROMOTION_TYPES = {
  SHORT_DATE: 'Promotions::ShortDate',
  TPR: 'Promotions::OnGoing',
  BUY_IN: 'Promotions::BuyIn'
}

export const SHORT_PROMOTION_TYPES = {
  SHORT_DATE: 'Short-date',
  TPR: 'Ongoing',
  BUY_IN: 'Buy-in'
}

export const PROMOTION_TYPE_HELP_TEXTS = {
  TPR: 'Temporary Price Reduction'
}

export const BUYER_EMAIL_GROUPS = {
  1: {
    id: 1,
    name: 'Admin',
    description: 'Emails related to payments and credits'
  },
  2: {
    id: 2,
    name: 'Order',
    description: 'Emails related to order management'
  }
}

export const BARCODE_TYPES = {
  UPC: 'Barcodes::Upc',
  EAN: 'Barcodes::Ean'
}

export const DELIVERY_METHODS = {
  SHIP_DIRECT_TO_STORE: 'ship_direct_to_store',
  SELF_DELIVER_TO_STORE: 'self_delivery_to_store'
}

// caution: region key orders affacts the cart item grouping behavior
export const REGION_TYPES = {
  PFD: 'Regions::Direct',
  WAREHOUSED: 'Regions::Warehoused',
  PFG: 'Regions::Direct::Deliverable::DeliveryType::PodGrow' // from FE side only
}

export const LIMIT_TYPES = {
  MOV: 'mov',
  MOQ: 'moq',
  NONE: 'none'
}

export const ITEM_TYPES = {
  PFD: 'LineItems::Direct',
  WAREHOUSED: 'LineItems::Warehoused',
  PFG: 'LineItems::Direct::Grow'
}

export const EXPORT_ITEM_TYPES = {
  [ITEM_TYPES.PFD]: 'Direct',
  [ITEM_TYPES.WAREHOUSED]: 'Express',
  [ITEM_TYPES.PFG]: 'Grow'
}

export const PAYMENT_TYPES = {
  INVOICE: 'Payment via invoice'
}

export const PRODUCT_AVAILABILITY = {
  IN_STOCK: 'in_stock',
  SOLD_OUT: 'sold_out',
  COMING_SOON: 'coming_soon'
}

export const LOS_ANGELES_CENTER = {
  lat: 39.850033,
  lng: -85.6500523
}

export const SHIPPO_COUNTRY_OPTIONS = [
  { id: 'US', name: 'US' },
  { id: 'CA', name: 'CANADA' }
]
export const GOOGLE_MAP_API_KEY = 'AIzaSyD1AHJj_gW7iPp8GnaG0ssa_K2Y6XwE5ns'
export const CHART_COLORS = ['#9b0b54', '#0071F1', '#FFA801', '#00B6CB', '#F75A01', '#2F9DDB', '#E3B873', '#3CA909', '#E4E5E6', '#D891C3', '#ff0029', '#377eb8', '#66a61e', '#984ea3', '#00d2d5', '#ff7f00', '#af8d00', '#7f80cd', '#b3e900', '#c42e60', '#a65628', '#f781bf', '#8dd3c7', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#fccde5', '#bc80bd', '#ffed6f', '#c4eaff', '#cf8c00', '#1b9e77', '#d95f02', '#e7298a', '#e6ab02', '#a6761d', '#0097ff', '#00d067', '#000000', '#252525', '#525252', '#737373', '#969696', '#bdbdbd', '#f43600', '#4ba93b', '#5779bb', '#927acc', '#97ee3f', '#bf3947', '#9f5b00', '#f48758', '#8caed6', '#f2b94f', '#eff26e', '#e43872', '#d9b100', '#9d7a00', '#698cff', '#d9d9d9', '#00d27e', '#d06800', '#009f82', '#c49200', '#cbe8ff', '#fecddf', '#c27eb6', '#8cd2ce', '#c4b8d9', '#f883b0', '#a49100', '#f48800', '#27d0df', '#a04a9b']
export const PREFIX_LP_DOMAIN = 'lp.'
export const PREFIX_BROKER_DOMAIN = 'broker.'

export const US_COUNTRY_ID = 1
export const CA_COUNTRY_ID = 2

export const BUYER_APPSTORE_URL = 'https://itunes.apple.com/app/id1543164275'
export const BUYER_PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=co.podfoods.heypod'
export const LP_APPSTORE_URL = 'https://itunes.apple.com/app/id1586798579'
export const LP_PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=co.podfoods.lp'

export const SUPPORT_URL = 'https://podfoods.co/help-center/get-started'
export const STORE_LIST_URL = 'https://docs.google.com/spreadsheets/u/1/d/e/2PACX-1vQJcNcMFs3BCThW1FWnpJIp0ZQhNZjkoYpdGq4ikujT4ZvurIPTyKlEsVEVXbhlM8UsBi9DDrQp2HSI/pubhtml'
export const WITHIN_7_BUSINESS_DAYS = 'within 7 business days'
export const CLAIMS_POLICY_LINK = 'https://view.monday.com/3792215887-2d816876b2bc783dae16304023aa60c0?r=use1&utm_source=hs_email&utm_medium=email'

export const BRAND_GUIDE_STORAGE_FEES_URL = 'https://view.monday.com/3674688828-1a46534afa9db71f1445025860bb12e8?r=use1#page=41'
export const BRAND_GUIDE_URL = 'https://view.monday.com/3674688828-1a46534afa9db71f1445025860bb12e8?r=use1'
export const CONSIGNMENT_TERMS_URL = 'https://view.monday.com/4094354432-6a5f437cc4bf52f7c0dc735ceef30f5c?r=use1'
export const CASE_PACK_REQUIREMENTS_URL = 'https://view.monday.com/4094824568-db1232ce77f0beeda4ab6f7a0c52d87d?r=use1'
export const BUYER_ORDER_FEEDBACK_IFRAME_URL = 'https://forms.monday.com/forms/embed/411632141a5d028d4b4cbfc93e80d09c'
export const POD_COST_SIGNUP_IFRAME_URL = 'https://forms.monday.com/forms/embed/9e7a1b9c1c21b5eb1f4edf67ea54b346'
export const CERTIFICATE_OF_INSURANCE_SAMPLE = '/downloads/certificate-of-insurance-sample-1.pdf'

// ['North California Express', 'South California Express', 'Pod Direct West'] abbreviated name
export const PROP_65_REGIONS = ['SF', 'LA', 'PDW']

export const ARRAY_SUFFIX = '_'
export const ARRAY_ITEM_DELIMITER = ','

export const ANALYTIC_PAGE_SIZE = 5
export const ANALYTIC_PAGER_COUNT = 5

export const VENDOR_CLAIM_ISSUES = [
  'Damaged Inventory',
  'Inventory Count Discrepancy',
  'Unprocessed Inventory',
  'Pricing Discrepancy',
  'Monthly Statement / Billing',
  'Other'
]

export const CLAIM_ISSUES = [
  'Shortage',
  'Damaged',
  'Mispick',
  'Expiration',
  'Short-Dated',
  'Product Defect',
  'Out of Stock',
  'Order ETA',
  'Cancel Order',
  'MISC'
]

export const INBOUND_INVENTORY_DELIVERY_METHODS = {
  FREIGHT_CARRIER_LTL: 'Freight Carrier / LTL',
  BRAND_SELF_DELIVERY: 'Brand Self Delivery',
  SMALL_PACKAGE_PARCEL: 'Small Package / Parcel'
}

export const INBOUND_INVENTORY_STATUS_TOOLTIPS = {
  pod_planned: 'Please review and confirm new inventory requests to stay in stock.',
  submitted: 'Your inventory submission has been approved and confirmed for inbound.',
  received: 'Pod is reviewing your inbound inventory received in our warehouse.',
  processed: 'Your inbound inventory is confirmed and ready for fulfillment.'
}

export const CAPITAL_S3_KANMON_DOCS_BUCKET =
  process.env.CAPITAL_S3_KANMON_DOCS_BUCKET ||
  'pfcapital-kanmon-docs-staging'

export const ERROR_HANDLING_MANUAL = 'ERROR_HANDLING_MANUAL'
export const PICKER_MAX_DAYS = 180
export const ETA_MAX_DAYS = 21
export const APPLY_PAYMENT_PAYOUT_DATE = '2023-05'
export const [US_ID, CANADA_ID] = [1, 2]

export const SHIPPO_ADDRESS_STATE = {
  UNVERIFIED: 'unverified',
  VALID: 'valid',
  INVALID: 'invalid'
}

export const FULL_TIME_UNITS = [
  { id: 'day', name: 'Daily' },
  { id: 'week', name: 'Weekly' },
  { id: 'month', name: 'Monthly' },
  { id: 'quarter', name: 'Quarterly' },
  { id: 'year', name: 'Yearly' }
]

export const TIME_UNITS = [
  { id: 'month', name: 'Monthly' },
  { id: 'quarter', name: 'Quarterly' },
  { id: 'year', name: 'Yearly' }
]

export const PRODUCT_RECOMMENDATION_GROUP = {
  A: 'a',
  B: 'b'
}

export const PRODUCT_CARD_TYPES = {
  DEFAULT: 'default',
  BRAND_DETAILS_GRID: 'brand_details_grid',
  RECOMMENDATION_GRID: 'recommendation_grid',
  RECOMMENDATION_CAROUSEL_HOME: 'recommendation_carousel_home',
  RECOMMENDATION_CAROUSEL_CATALOG: 'recommendation_carousel_catalog',
  RECOMMENDATION_CAROUSEL_ORDER_GUIDE: 'recommendation_carousel_order_guide'
}

export const POD_EXPRESS_EXPLANATION = 'Fast delivery, fully consolidated.'
export const POD_EXPRESS_EXPLANATION_IN_PLURAL = 'These items will be consolidated and delivered to you from our distribution centers.'

export const POD_DIRECT_EXPLANATION = 'This item will be shipped directly to you from the vendor.'
export const POD_DIRECT_EXPLANATION_IN_PLURAL = 'These items will be delivered directly from the vendors.'

export const POD_GROW_EXPLANATION = 'This item will be shipped by a faster parcel service from Pod warehouse.'
export const POD_GROW_EXPLANATION_IN_PLURAL = 'These items will be shipped by a faster parcel service from Pod warehouse.'

export const SHIPPO_AUTO_GENERATED_COMMENT = 'Shippo auto-generated'

export const PRESS_RELEASES = [
  {
    url: 'https://www.youtube.com/watch?v=HUnnAn3to6M&t=4793s',
    title: 'Big AI Selloff Today | Bloomberg Markets: The Close 04/19/2024',
    logo: '/img/articles/bloomberg.svg'
  },
  {
    url: 'https://techcrunch.com/2021/12/09/pod-foods-grocery-supply-chain/',
    title: 'Pod bags additional funding to overhaul the grocery supply chain',
    logo: '/img/articles/techcrunch.svg'
  },
  {
    url: 'https://progressivegrocer.com/pod-foods-capital-launches',
    title: 'Pod Capital Launches',
    logo: '/img/articles/progressive-grocer.svg'
  },
  {
    url: 'https://www.forbes.com/sites/geristengel/2021/12/15/how-founders-leveraged-their-network-to-disrupt-the-grocery-supply-chain/',
    title: 'How Founders Leveraged Their Network To Disrupt The Grocery Supply Chain',
    logo: '/img/articles/forbes.svg'
  },
  {
    url: 'https://www.fastcompany.com/90724410/most-innovative-companies-food-2022',
    title: 'The 10 most innovative food companies of 2022',
    logo: '/img/articles/fast-company.svg'
  },
  {
    url: 'https://www.wsj.com/business/retail/food-inflation-mysterious-fees-distributors-ed17bb45',
    title: 'The Mysterious Fees Inflating Your Grocery Bill',
    logo: '/img/articles/the-wall-street-journal.svg'
  }
]
export const SOCIAL_NETWORKS = [
  { network: 'facebook', name: 'Facebook', icon: 'bxl-facebook', prefix: 'https://facebook.com/', username: '' },
  { network: 'youtube', name: 'Youtube', icon: 'bxl-youtube', prefix: 'https://youtube.com/@', username: '' },
  { network: 'instagram', name: 'Instagram', icon: 'bxl-instagram', prefix: 'https://instagram.com/', username: '' },
  { network: 'tiktok', name: 'Tiktok', icon: 'bxl-tiktok', prefix: 'https://tiktok.com/@', username: '' },
  { network: 'twitter', name: 'Twitter', icon: 'bxl-twitter', prefix: 'https://x.com/', username: '' },
  { network: 'linkedin', name: 'Linkedin', icon: 'bxl-linkedin', prefix: 'https://linkedin.com/company/', username: '' }
]

export const YOUTUBE_REGEX = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
export const VIMEO_REGEX = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i

export const TESTIMONIAL_TYPES = {
  POD_CREATIVE: 'Pod Creative',
  BRAND: 'Brand',
  RETAILER: 'Retailer',
  OTHERS: 'Others'
}
